var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 5.00063C0 4.86802 0.0526784 4.74085 0.146447 4.64708C0.240215 4.55331 0.367392 4.50063 0.5 4.50063H12.293L9.146 1.35463C9.05211 1.26075 8.99937 1.13341 8.99937 1.00063C8.99937 0.867856 9.05211 0.740518 9.146 0.646631C9.23989 0.552745 9.36722 0.5 9.5 0.5C9.63278 0.5 9.76011 0.552745 9.854 0.646631L13.854 4.64663C13.9006 4.69308 13.9375 4.74825 13.9627 4.809C13.9879 4.86974 14.0009 4.93486 14.0009 5.00063C14.0009 5.0664 13.9879 5.13152 13.9627 5.19226C13.9375 5.25301 13.9006 5.30819 13.854 5.35463L9.854 9.35463C9.76011 9.44852 9.63278 9.50126 9.5 9.50126C9.36722 9.50126 9.23989 9.44852 9.146 9.35463C9.05211 9.26074 8.99937 9.13341 8.99937 9.00063C8.99937 8.86786 9.05211 8.74052 9.146 8.64663L12.293 5.50063H0.5C0.367392 5.50063 0.240215 5.44795 0.146447 5.35419C0.0526784 5.26042 0 5.13324 0 5.00063V5.00063Z",
  fill: "#5B57EA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/arrowRight.9c4165ffa2bb2be127017b22fcc5a4e2.svg";